<div class="rackCacheContent"> 
  <div class="rackCacheHeader" i18n>Rack Cache</div>          

    <mat-form-field class="my-form-field buildingFilterField">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="buildingFilter($event)">
      </mat-form-field>

    <div class="container">
      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selectionModel.hasValue() && isAllSelected()"
                          [indeterminate]="selectionModel.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selectionModel.toggle(row) || add(row,$event) : null"
                          [checked]="selectionModel.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-divider></mat-divider>

    <div class="cacheQuestion" i18n>Building types selection</div> 
    <div class="cacheWarning" i18n>Caching time is dependent on the time required to cache all the racks in the building types selected. Therefore, select only the most important building types to cache the racks inside them. Otherwise the caching time may extend to several hours or even days.</div> 

    <div class="buttonContent">
      <button mat-raised-button type="button" color="primary" (click)="onSave()" i18n>SAVE</button>
    </div>    
</div>